// extracted by mini-css-extract-plugin
export var bullet = "_m5-q";
export var bulletText = "_m5-p";
export var bullets = "_m5-k";
export var callout = "_m5-g";
export var calloutBody = "_m5-i";
export var calloutLabel = "_m5-h";
export var checkIcon = "_m5-m";
export var checkList = "_m5-j";
export var checkSvg = "_m5-n";
export var checkText = "_m5-o";
export var fieldCard = "_m5-1";
export var fieldDescription = "_m5-5";
export var fieldHeader = "_m5-3";
export var fieldTitle = "_m5-4";
export var finalNote = "_m5-s";
export var flow = "_m5-x";
export var flowArrow = "_m5-v";
export var flowStep = "_m5-u";
export var helperText = "_m5-r";
export var inlineTitle = "_m5-t";
export var listItem = "_m5-l";
export var noteBody = "_m5-8";
export var noteBodyText = "_m5-9";
export var noteCard = "_m5-2";
export var noteIcon = "_m5-6";
export var noteTitle = "_m5-7";
export var productChoices = "_m5-w";
export var radioDot = "_m5-d";
export var radioDotSelected = "_m5-e";
export var radioDotSvg = "_m5-f";
export var selectableCard = "_m5-b";
export var selectableCardSelected = "_m5-c";
export var strongText = "_m5-a";
export var subHeading = "_m5-0";